export default "__VITE_ASSET__bb73e208__"